import { render, staticRenderFns } from "./BaseTLModalDialogDetail.vue?vue&type=template&id=f6da8810&"
import script from "./BaseTLModalDialogDetail.vue?vue&type=script&lang=ts&"
export * from "./BaseTLModalDialogDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports